import React from "react"

import {
	Grid,
} from "@mui/material"

import {
	mdiAirport,
	mdiBaguette,
	mdiBank,
	mdiBasket,
	mdiBicycleBasket,
	mdiCarMultiple,
	mdiCart,
	mdiCellphoneBasic,
	mdiCoffee,
	mdiFaceWomanShimmer,
	mdiFoodVariant,
	mdiHanger,
	mdiHospitalBuilding,
	mdiLibrary,
	mdiLibraryShelves,
	mdiMedication,
	mdiNecklace,
	mdiParking,
	mdiPaw,
	mdiRvTruck,
	mdiShoeHeel,
	mdiSilverwareForkKnife,
	mdiStore24Hour,
	mdiStorefront,
	mdiWarehouse,
} from "@mdi/js"

import { AssetCharacteristics } from "models"

import {
	AttractorItem,
	DashboardMapAttractorItem,
} from "./dashboard-map-attractor-item"

interface DashboardMapAttractorsProps
{
	characteristics: AssetCharacteristics
}
export class DashboardMapAttractors extends React.Component<DashboardMapAttractorsProps, {}>
{
	private items: AttractorItem[] = [
		new AttractorItem("Aeroporti", mdiAirport, "airport"),
		new AttractorItem("Banche", mdiBank, "bank"),
		new AttractorItem("Bar", mdiCoffee, "bar"),
		new AttractorItem("Biblioteche", mdiLibrary, "library"),
		new AttractorItem("Centri commerciali", mdiStore24Hour, "shopping_mall"),
		new AttractorItem("Concessionarie", mdiCarMultiple, "car_dealer"),
		new AttractorItem("Farmacie", mdiMedication, "pharmacy"),
		new AttractorItem("Gioiellerie", mdiNecklace, "jewelry_store"),
		new AttractorItem("Grandi magazzini", mdiShoeHeel, "department_store"),
		new AttractorItem("Librerie", mdiLibraryShelves, "book_store"),
		new AttractorItem("Magazzini", mdiWarehouse, "storage"),
		new AttractorItem("Minimarket", mdiBasket, "convenience_store"),
		new AttractorItem("Negozi di abbigliamento", mdiHanger, "clothing_store"),
		new AttractorItem("Negozi di articoli per la casa", mdiFoodVariant, "home_goods_store"),
		new AttractorItem("Negozi di biciclette", mdiBicycleBasket, "bicycle_store"),
		new AttractorItem("Negozi di elettronica", mdiCellphoneBasic, "electronics_store"),
		new AttractorItem("Negozi per animali", mdiPaw, "pet_store"),
		new AttractorItem("Negozi vari", mdiStorefront, "store"),
		new AttractorItem("Ospedali", mdiHospitalBuilding, "hospital"),
		new AttractorItem("Panifici", mdiBaguette, "bakery"),
		new AttractorItem("Parcheggi", mdiParking, "parking"),
		new AttractorItem("Parcheggi camper", mdiRvTruck, "rv_park"),
		new AttractorItem("Ristoranti", mdiSilverwareForkKnife, "restaurant"),
		new AttractorItem("Saloni di bellezza", mdiFaceWomanShimmer, "beauty_salon"),
		new AttractorItem("Supermercati", mdiCart, "supermarket"),
	]

	render()
	{
		return (
			<Grid container columnSpacing={5} rowSpacing={0.5} sx={{ fontSize: "0.65em" }}>
				{this.items.map(it => (
					<Grid item xs={6}>
						<DashboardMapAttractorItem
							item={it}
							characteristics={this.props.characteristics} />
					</Grid>
				))}
			</Grid>
		)
	}
}
